/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { LoginFacade } from '@cigna/cigna-for-brokers/login-data-access';
import { takeUntil, Subject } from 'rxjs';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { ContactUsComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cigna-caheader-impersonator',
  templateUrl: './header-impersonator.component.html',
  styleUrls: ['./header-impersonator.component.scss'],
})
export class HeaderImpersonatorComponent implements OnInit, OnDestroy {
  @Input() isImpersonationUser: boolean;
  @Input() isImpersonatorSignin: boolean;
  @Input() canEnableImpersonatorLogout: boolean;
  @Input() impFirstName: string | undefined;
  @Input() impLastName: string | undefined;
  @Input() operatorId: string | undefined;

  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  isOktaLoginEnabled: boolean;
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  constructor(
    private appStateFacade: AppstateFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
    public _loginFacade: LoginFacade,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOktaLoginEnabled: boolean) => {
        this.isOktaLoginEnabled = isOktaLoginEnabled;
      });
  }

  processLogout(isImpersonatorSignin: boolean) {
    localStorage.setItem('isfromImpersonator', 'true');

    if (this.isOktaLoginEnabled) {
      this._loginFacade.impersonatorLogout();
    } else {
      this.appStateFacade.impersonatorLogOut(isImpersonatorSignin);
    }
  }

  showContactModal() {
    this.dialog.open(ContactUsComponent, {
      width: '40rem',
      autoFocus: false,
      disableClose: true,
    });
  }

  ngOnDestroy() {
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }
}
